import React, { useState } from 'react'
import styles from './styles.module.css'
import { classNames } from '@monorepo/utils'
import visibilityIcon from '../../images/visibility_icon.svg'
import visibilityOffIcon from '../../images/visibility_off_icon.svg'
import { useTranslation } from 'react-i18next'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  prefixIcon?: React.ReactNode
  errorMsg?: React.ReactElement | string
}

const Input: React.FC<Props> = ({ prefixIcon, errorMsg, type, ...props }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === 'password'

  const togglePassword = () => setShowPassword(prev => !prev)

  return (
    <div className={styles.container}>
      <div className={classNames(styles.input, prefixIcon && styles.prefixInline)}>
        {prefixIcon}
        <input
          {...props}
          type={isPassword ? (showPassword ? 'text' : 'password') : type}
        />
        {isPassword && (
          <img className={styles.eyeIcon} src={showPassword ? visibilityOffIcon : visibilityIcon } onClick={togglePassword}/>
        )}
      </div>
      {errorMsg ? <div className={styles.errorMsg} >{typeof errorMsg === 'string' ? t(errorMsg) : errorMsg}</div> : <div className={styles.reservedSpace}></div>}
    </div>
  )
}

export default Input
